import emailjs from "@emailjs/browser";
import Push from "push.js";
import React, { useState, useEffect } from "react";
import { getDownloadURL, ref, uploadString } from "firebase/storage";
import { storage } from "./firebase-config";
import { isMobile } from "react-device-detect";
import * as tf from "@tensorflow/tfjs";

import { usePush, useUserEmail, useUserName } from "./Store";

import Button from "@mui/material/Button";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import Webcam from "react-webcam";

const videoConstraints = {
  width: 640,
  height: 480,
  facingMode: "",
};

if (isMobile) {
  videoConstraints.facingMode = "user";
} else {
  videoConstraints.facingMode = "environment";
}

export const WebcamCapture = () => {
  // image from webcam
  const [image, setImage] = useState("");
  const webcamRef = React.useRef(null);

  // Load custom model
  const url = "https://yiheng822.github.io/model-json/model.json";
  const [model, setModel] = useState();

  // Prediction on Image
  const [result, setResult] = useState("");
  const [isFall, setIsFall] = useState(false);
  const [imageStr, setImageStr] = useState("");

  // Push & Email notification
  const isPush = usePush();
  const userEmail = useUserEmail();
  const userName = useUserName();
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const [toast, setToast] = useState("");
  const [status, setStatus] = useState("info");
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [imageURL, setImageURL] = useState("");

  // capture image
  useEffect(() => {
    const id = setInterval(capture, 1500);
    return () => clearInterval(id);
  }, []);

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
  }, [webcamRef, setImage]);

  // machine learning model
  class L2 {
    static className = "L2";

    constructor(config) {
      return tf.regularizers.l1l2(config);
    }
  }
  tf.serialization.registerClass(L2);

  async function loadModel(url) {
    try {
      const model = await tf.loadLayersModel(url);
      setModel(model);
      setStatus("success");
      setToast("Prediction model loaded");
    } catch (err) {
      console.log(err);
      setStatus("error");
      setToast("Error loading model. Check console for full error.");
    }
  }

  useEffect(() => {
    tf.ready().then(() => {
      loadModel(url);
    });
  }, []);

  // prediction
  const predict = async () => {
    if (image) {
      try {
        var imageObj = new Image(640, 480);
        setImageStr(image);
        imageObj.src = imageStr;
        const tensor = tf.browser.fromPixels(imageObj).expandDims();
        if (tensor) {
          setResult(model.predict(tensor));
        }
        if (result) {
          if (
            parseFloat(
              result
                .toString()
                .match(/\[(.*?)\]/)[1]
                .slice(1)
            ) > 0.5
          ) {
            if (!isFall) {
              if (userEmail) {
                uploadImage(imageStr, userEmail);
              }
            }
            if (isPush) {
              sendPush();
            }
            setIsFall(true);
          }
          console.log(isFall);
          result.dispose();
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  useEffect(() => {
    predict();
  }, [image]);

  const sendEmail = async (url) => {
    let currentDate = new Date();
    let cDate =
      currentDate.getFullYear() +
      "-" +
      (currentDate.getMonth() + 1) +
      "-" +
      currentDate.getDate();
    let cTime =
      currentDate.getHours() +
      ":" +
      currentDate.getMinutes() +
      ":" +
      currentDate.getSeconds();
    let dateTime = cDate + " " + cTime;

    var templateParams = {
      date_time: dateTime,
      user_name: userName,
      user_email: userEmail,
      image_url: url,
    };

    emailjs
      .send(
        "fall_detected",
        "fall_template",
        templateParams,
        "wZFz9uN2MEtVF-DrN"
      )
      .then(
        function (response) {
          setIsEmailSent(true);
          setStatus("success");
          setToast("Email successfully sent to " + userEmail);
        },
        function (error) {
          setIsEmailSent(true);
          setStatus("error");
          setToast("Error sending email: " + error);
        }
      );
  };

  const sendPush = () => {
    Push.create("Fall occurred", {
      body: "A fall is detected! Please check the person in the room.",
      icon: "./alert-32x32.png",
      timeout: 5000,
      onClick: function () {
        window.focus();
        this.close();
      },
    });
  };

  const uploadImage = async (file, email) => {
    if (!file) return;
    const storageRef = ref(storage, `/images/${email}/fall.jpg`);
    const metadata = {
      contentType: "image/jpeg",
    };
    const imageStr = file.toString().match(/,([\s\S]*)$/)[1];

    uploadString(storageRef, imageStr, "base64", metadata).then((result) => {
      getDownloadURL(result.ref).then((url) => {
        setImageURL(url);
        sendEmail(url);
      });
    });
    return imageURL;
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setToast("");
    setIsEmailSent(false);
  };

  const clearSession = () => {
    setIsFall(false);
    setImageURL("");
  };

  return (
    <div>
      <div className="flex center">
        {isFall && (
          <Button
            color="secondary"
            variant="outlined"
            sx={{ mb: 1 }}
            onClick={clearSession}
          >
            A fall is detected, please click here to resume the detection
          </Button>
        )}
        <Webcam
          audio={false}
          height={480}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          width={640}
          videoConstraints={videoConstraints}
        />
      </div>
      <Snackbar
        open={isEmailSent}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={status} sx={{ width: "100%" }}>
          {toast}
        </Alert>
      </Snackbar>
    </div>
  );
};
